import * as PaymentActionTypes from '../actions/payments';

import initialState from './initialState';

export default (state=initialState.payments, action) => {
    const { payload, type } = action;

    switch(type) {
        
        case PaymentActionTypes.FETCH_PAYMENTS:
        case PaymentActionTypes.FETCH_PAYMENTS_PENDING:
            return { ...state, payments_loading: true }

        case PaymentActionTypes.FETCH_PAYMENTS_REJECTED:
            return { ...state, payments_loading: false, error: payload.error, errorMessage: payload.response.data }

        case PaymentActionTypes.FETCH_PAYMENTS_FULFILLED:
            return { ...state, payments_loading: false, payments: payload.data }
        

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/payments.js